<template>
  <div>
    <shop-head currentPageName="aboutUs"></shop-head>
    <div class="container">
      <div class="img-box">
        <img :src="aboutInfo[0].url" alt="">
      </div>
      <div class="video">
        <video controls :src="aboutInfo[1].url" type="video/mp4">
        </video>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import shopHead from '../../components/shop/head'
import commonFooter from '../../components/common/footer'
import { getAboutUsInfo } from '../../apis/aboutUs'
export default {
  components: {
    shopHead,
    commonFooter
  },
  data() {
    return {
      aboutInfo: [[], []]
    }

  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const result = await getAboutUsInfo();
      this.aboutInfo = result.data
    }
  }
}
</script>

<style lang="scss" scoped>
.img-box {
  width: 100%;

  img {
    width: 90%;
    height: auto;
    display: block;
    margin: 20px auto;
  }
}

.text {
  width: 100%;
  line-height: 26px;
  font-size: 16px;
  text-align: justify;

  &.bottom {
    margin-bottom: 20px;
  }
}

.video {
  width: 100%;
  margin: 0 auto;
  text-align: center;

  video {
    width: 80%;
  }
}
</style>